// extracted by mini-css-extract-plugin
module.exports = {"container":"Inclusions_container__1tBCa","chart":"Inclusions_chart__2hBxM","select":"Inclusions_select__2Okns"};